import { render, staticRenderFns } from "./text-templates-modal.vue?vue&type=template&id=3f3ecb74&scoped=true&"
import script from "./text-templates-modal.ts?vue&type=script&lang=ts&"
export * from "./text-templates-modal.ts?vue&type=script&lang=ts&"
import style0 from "./text-templates-modal.scss?vue&type=style&index=0&id=3f3ecb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ecb74",
  null
  
)

export default component.exports